<template>
  <aside class="left-sidebar" :class="Sidebar_drawer ? `show-sidebar bg-${SidebarColor}` : `bg-${SidebarColor}`">
    <VuePerfectScrollbar class="scrlbar">
      <div :class="`bg-${logoColor} navbar-header`">
        <LogoLight class="mx-auto mt-0 d-flex w-100" />
        <span class="d-block d-lg-none close-sidebar-btn" @click="showMobileSidebar">
          <feather class="mr-2 feather-sm" type="x" />
        </span>
      </div>
      <ul class="nav flex-column mb-0">
        <template v-for="(route, i) in listaSideBar">
          <!---Menu Title -->
          <li class="nav-item" :key="route.header" v-if="route.header">
            <div class="d-flex nav-small-cap">
              <span class="hide-text mt-5">{{ $t(`${route.header}`) }}</span>
            </div>
          </li>
          <!---Sub Menu -->
          <li class="nav-item" :key="route.title" v-if="route.childern">
            <a class="nav-link d-flex" v-b-toggle="route.id">
              <feather :type="route.icon"></feather>
              <span class="hide-text">{{ $t(route.i18n) || route.title }}</span>
              <em class="ti ti-angle-down dd-arrow ml-auto hide-text"></em>
            </a>
            <b-collapse :id="route.id" accordion="sidebar-accordion"
              :visible="$route.path == `${route.name + $route.name.replace(/\s+/g, '-').toLowerCase()}`">
              <ul class="nav flex-column sub-menu">
                <template v-for="(subroute, i) in route.childern">
                  <li class="nav-item" :key="i">
                    <router-link class="nav-link d-flex" :to="subroute.to">
                      <em :class="subroute.icon"></em>
                      <span class="hide-text">{{ subroute.title }}</span>
                    </router-link>
                  </li>
                </template>
              </ul>
            </b-collapse>
          </li>
          <!---Single Menu -->
          <li class="nav-item" :key="i" v-if="!route.childern && !route.header" @click="showMobileSidebar">
            <router-link :to="`${route.to}`" class="nav-link d-flex">
              <feather :type="route.icon"></feather>
              <span class="hide-text" id="menuTex">{{ $t(route.i18n) || route.title }}</span>
            </router-link>
          </li>
        </template>
      </ul>
    </VuePerfectScrollbar>
  </aside>
</template>

<script>
import LogoDark from "../logo-dark/LogoDark";
import LogoLight from "../logo-light/LogoLight";
import { mapState } from "vuex";
import SidebarData from "./SidebarData";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: "VerticalSidebar",
  components: {
    LogoDark,
    LogoLight,
    VuePerfectScrollbar
  },
  data: () => ({
    initialShow: true,
    routes: SidebarData,
  }),
  computed: {
    ...mapState(["logoColor", "Sidebar_drawer", "SidebarColor"]),
    check() {
      return console.log(this.$router.history.current);
    },
    listaSideBar() {
      let sideBarTemp = [...this.routes];
      const idRol = sessionStorage.idRol;

      if (idRol != null) {
        let idsARemover = new Set();

        // --- Definición de restricciones por Rol ---

        // Rol: Usuario Final
        if (idRol == process.env.VUE_APP_ID_USUARIO_FINAL) {
          idsARemover = new Set(["2", "6", "7", "8", "9", "10", "11", "12"]);
        }

        // Rol: Administrador
        else if (idRol == process.env.VUE_APP_ID_ADMINISTRADOR) {
          idsARemover = new Set(["8", "9", "10", "11", "12"]);
        }

        // Rol: Master (Vista simulada de otro usuario mediante filtro)
        else if (idRol == process.env.VUE_APP_ID_MASTER && sessionStorage.getItem("usuarioFiltro") !== "") {
          const usuarioFiltro = JSON.parse(sessionStorage.getItem("usuarioFiltro"));

          // Si el Master está visualizando como un Administrador
          if (usuarioFiltro.rol.id == process.env.VUE_APP_ID_ADMINISTRADOR) {
            idsARemover = new Set(["8", "9", "10", "11", "12"]);
          }
          // Si el Master está visualizando como cualquier otro perfil (ej. Usuario Final)
          else {
            idsARemover = new Set(["2", "6", "7", "8", "9", "10", "11", "12"]);
          }
        }

        // --- Aplicación del filtro de seguridad ---
        // Se usa .has() para una búsqueda de alta eficiencia ($O(1)$)
        if (idsARemover.size > 0) {
          sideBarTemp = sideBarTemp.filter(item => !idsARemover.has(item.id));
        }
      }

      return sideBarTemp;
    },
  },
  methods: {
    showMobileSidebar() {
      this.$store.commit("SET_SIDEBAR_DRAWER", false);
    },

  },
};
</script>

<style>
#menuTex {
  font-weight: 300;
}

@media (max-width: 991.98px) and (max-height: 950px) {
  #menuTex {
    font-weight: 400;
  }
}
</style>